import { ComponentStyleConfig } from '@chakra-ui/react';

export const Popover: ComponentStyleConfig = {
    baseStyle: {
        popper: {
            zIndex: 'popover'
        }
    }
};
